<template>
  <div>
    <div class="scrollbar_top">
      <router-link v-if="sidebar.opened" key="collapse" class="sidebar-logo-link" to="/">
        <img :src="logo" class="sidebar-logo">
      </router-link>
      <hamburger class="hamburger-container" :toggle-click="toggleSideBar" :is-active="sidebar.opened" />
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper-list">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" background-color="#ffffff" text-color="#333333" :unique-opened="true" active-text-color="#248BFF" mode="vertical">
        <sidebar-item v-for="(route, index) in sidebarRouters" :key="route.path + index" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import Hamburger from '@/components/Hamburger'
import logoImg from '@/assets/logo/logo.png'

export default {
  components: { SidebarItem, Hamburger },
  data() {
    return {
      deptFullNameFirst: '简',
      logo: logoImg
    }
  },
  computed: {
    ...mapGetters(['sidebarRouters', 'sidebar']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    isCollapse() {
      return !this.sidebar.opened
    }
    // currentGroupLogoUrl() {
    //   return this.$store.state.user.userData.currentGroupLogoUrl || ''
    // },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    }
  }
}
</script>

<style lang="scss">
.scrollbar-wrapper-list {
  overflow-x: hidden !important;
  margin-bottom: 0px !important;

  .el-scrollbar__view {
    height: calc(100vh - 60px);
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";

.scrollbar_top {
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 10px;
  box-sizing: border-box;

  .sidebar-logo-link {
    width: 100%;

    .sidebar-logo {
      display: block;
      width: 142px;
      height: 28px;
    }
  }
}
</style>
